import { render, staticRenderFns } from "./OblykCarouselItem.vue?vue&type=template&id=bc0010ca"
import script from "./OblykCarouselItem.vue?vue&type=script&lang=js"
export * from "./OblykCarouselItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports